exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabledSelect__select___2lyWt {\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"select": "disabledSelect__select___2lyWt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/IndexSelect/DisabledSelect/disabledSelect.scss
// module id = 4180
// module chunks = 6